import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const organizationResetMutationAtom = createMutationAtomFactory(
  'admin.organizationReset',
  (params: { organizationId: string }) => ({
    coreOrganizationReset: {
      __args: {
        organizationId: params.organizationId,
      },
      newOrganizationId: true,
      newFacilityId: true,
      success: true,
    },
  }),
);
